module.exports = __webpack_public_path__ + "img/about_banner.7d5328ab.png";